/* ============================================================
   Lucy Mae & Co. — Theme interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastEl = document.getElementById('lm-toast');
  var toastTimer;
  window.LMToast = function (message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  };

  /* ---------- Header scroll state + height ---------- */
  var header = document.querySelector('[data-header]');
  var headerRoot = document.querySelector('[data-header-root]');

  /* The header is fixed, so its height is measured and published as a CSS
     variable. A hardcoded value breaks as soon as the announcement bar is
     switched off or the nav wraps on a narrow viewport. */
  function syncHeaderHeight() {
    if (!headerRoot) return;
    // Measure whatever is actually pinned. On phones the wrap goes static and
    // only the header stays, so publishing the wrap's height would leave the
    // sticky add-to-cart bar floating 80px below the header it should hug.
    var isFixed = getComputedStyle(headerRoot).position === 'fixed';
    var pinned = isFixed ? headerRoot : (header || headerRoot);
    var h = pinned.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--lm-header-h', h + 'px');

    // Everything above the header — announcement bar plus sale marquee. Worked
    // out from the layout itself rather than hardcoded, so switching a bar off
    // in the editor keeps the mobile offset correct. Measured whether the wrap
    // is fixed or not: it is the gap inside the wrap that matters.
    var preheadH = 0;
    if (header) {
      var offset = header.getBoundingClientRect().top - headerRoot.getBoundingClientRect().top;
      // While condensed the wrap is translated up, which would read back as 0.
      if (!headerRoot.classList.contains('is-condensed')) {
        preheadH = Math.max(0, Math.round(offset));
        headerRoot.setAttribute('data-prehead', preheadH);
      } else {
        preheadH = parseInt(headerRoot.getAttribute('data-prehead'), 10) || 0;
      }
    }
    document.documentElement.style.setProperty('--lm-prehead-h', preheadH + 'px');
  }
  // Phones only: hide the announcement bar and sale marquee once the page
  // moves, so the header alone follows the shopper down.
  function syncCondensedHeader() {
    if (!headerRoot) return;
    var narrow = window.matchMedia('(max-width: 859px)').matches;
    var prehead = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lm-prehead-h')) || 0;
    var condense = narrow && prehead > 0 && window.scrollY > prehead;
    headerRoot.classList.toggle('is-condensed', condense);
    // The sticky add-to-cart bar hangs off this, so it has to follow suit.
    var visible = condense && header ? header.getBoundingClientRect().height : headerRoot.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--lm-header-h', visible + 'px');
  }
  window.addEventListener('scroll', function () { syncHeaderHeight(); syncCondensedHeader(); }, { passive: true });

  syncHeaderHeight();
  syncCondensedHeader();
  window.addEventListener('resize', function () { syncHeaderHeight(); syncCondensedHeader(); });
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
  if (window.ResizeObserver && headerRoot) {
    new ResizeObserver(syncHeaderHeight).observe(headerRoot);
  }

  if (header && header.getAttribute('data-transparent') === 'true') {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotation ---------- */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var raw = announce.getAttribute('data-messages') || '';
    var messages = raw.split('|').map(function (m) { return m.trim(); }).filter(Boolean);
    if (messages.length > 1) {
      var idx = 0;
      setInterval(function () {
        idx = (idx + 1) % messages.length;
        announce.textContent = messages[idx];
      }, 3000);
    }
  }

  /* ---------- Search dropdown ---------- */
  (function initSearchDropdown() {
    var wrap = document.querySelector('.lm-search-wrap');
    var input = document.querySelector('[data-search-input]');
    var dropdown = document.querySelector('[data-search-dropdown]');
    if (!wrap || !input || !dropdown) return;

    var hideTimer;
    function show() { clearTimeout(hideTimer); dropdown.hidden = false; }
    function hide() { hideTimer = setTimeout(function () { dropdown.hidden = true; }, 150); }

    input.addEventListener('focus', show);
    input.addEventListener('blur', hide);
    dropdown.addEventListener('mouseenter', show);
    dropdown.addEventListener('mouseleave', hide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { dropdown.hidden = true; input.blur(); }
    });
  })();

  /* ---------- Stats count-up (10,000+ / 2011 / 14-Day / 50 States) ---------- */
  (function initStatsCountUp() {
    var nums = document.querySelectorAll('[data-stat-number]');
    if (!nums.length) return;

    function animate(el) {
      var raw = el.getAttribute('data-stat-number') || '';
      var match = raw.match(/^([\d,]+)(.*)$/);
      if (!match) return;
      var target = parseInt(match[1].replace(/,/g, ''), 10);
      var suffix = match[2] || '';
      var hasComma = match[1].indexOf(',') > -1;
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var value = Math.round(target * progress);
        var display = hasComma ? value.toLocaleString('en-US') : String(value);
        el.textContent = display + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      nums.forEach(function (el) { observer.observe(el); });
    } else {
      nums.forEach(animate);
    }
  })();

  /* ---------- Trust testimonial carousel ---------- */
  (function initTrustCarousel() {
    document.querySelectorAll('.lm-trust').forEach(function (section) {
      var slides = section.querySelectorAll('[data-trust-slide]');
      var dots = section.querySelectorAll('[data-trust-dot]');
      if (slides.length < 2) return;
      var index = 0;
      function show(i) {
        index = i;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { show(i); resetTimer(); });
      });
      var timer;
      function resetTimer() {
        clearInterval(timer);
        timer = setInterval(function () { show((index + 1) % slides.length); }, 5000);
      }
      resetTimer();
    });
  })();

  /* ---------- Shop mega menu (hover with tolerance, no gap-close) ---------- */
  (function initShopMegaMenu() {
    var wrap = document.querySelector('.lm-shop-wrap');
    var dropdown = document.querySelector('.lm-shop-dropdown');
    if (!wrap || !dropdown) return;

    var hideTimer;
    function show() { clearTimeout(hideTimer); dropdown.classList.add('is-open'); }
    function hide() { hideTimer = setTimeout(function () { dropdown.classList.remove('is-open'); }, 250); }

    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hide);
    dropdown.addEventListener('mouseenter', show);
    dropdown.addEventListener('mouseleave', hide);
  })();

  /* ---------- Help dropdown (announcement bar) — same hover tolerance ---------- */
  (function initHelpDropdown() {
    document.querySelectorAll('.lm-help-wrap').forEach(function (wrap) {
      var dropdown = wrap.querySelector('.lm-help-dropdown');
      if (!dropdown) return;
      var hideTimer;
      function show() { clearTimeout(hideTimer); dropdown.classList.add('is-open'); }
      function hide() { hideTimer = setTimeout(function () { dropdown.classList.remove('is-open'); }, 250); }
      wrap.addEventListener('mouseenter', show);
      wrap.addEventListener('mouseleave', hide);
      dropdown.addEventListener('mouseenter', show);
      dropdown.addEventListener('mouseleave', hide);
    });
  })();

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    if (!mobileMenu) return;
    var isOpen = mobileMenu.classList.toggle('is-open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    document.querySelectorAll('[data-menu-toggle][aria-expanded]').forEach(function (b) {
      b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* ---------- Product sliders (New Arrivals, Best Sellers, You May Also Like) ---------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var wrap = slider.closest('section');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-slider-prev]');
    var next = wrap.querySelector('[data-slider-next]');
    var step = function () {
      var card = slider.querySelector('.lm-card');
      var gap = parseFloat(getComputedStyle(slider).gap) || 20;
      return card ? card.getBoundingClientRect().width + gap : 220;
    };
    // The row runs in a circle both ways: past the last card the next arrow
    // returns to the first, and from the first the previous arrow goes to the
    // last. Stopping at the start was tried instead, because the jump reads at
    // first like an arrow pointing the wrong way, but a dead arrow is worse -
    // it says the row is broken rather than that it has run out.
    var maxScroll = function () { return slider.scrollWidth - slider.clientWidth; };
    var aanRand = 2; // speling, want een browser rondt scrollposities af

    var ga = function (richting) {
      var eind = maxScroll();
      if (eind <= 0) return;
      if (richting > 0 && slider.scrollLeft >= eind - aanRand) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (richting < 0 && slider.scrollLeft <= aanRand) {
        slider.scrollTo({ left: eind, behavior: 'smooth' });
        return;
      }
      slider.scrollBy({ left: richting * step() * 2, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', function () { ga(-1); });
    if (next) next.addEventListener('click', function () { ga(1); });

    // A row whose cards all fit has nothing to scroll, and two arrows that do
    // nothing when pressed say the row is broken. They come back by themselves
    // once there are more cards than fit, or the window gets narrower.
    var toonPijlen = function () {
      var nodig = maxScroll() > 1;
      if (prev) prev.hidden = !nodig;
      if (next) next.hidden = !nodig;
    };
    toonPijlen();
    window.addEventListener('resize', toonPijlen, { passive: true });
    // Until the photographs are in, the row is narrower than it will be.
    slider.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', toonPijlen);
    });
  });

  /* ---------- Review slider on the product page ----------
     Native scroll does the moving; the arrows and dots only steer it, so a
     swipe on a phone and a click on a desktop end up in the same place. */
  document.querySelectorAll("[data-revslider]").forEach(function (wrap) {
    var track = wrap.querySelector("[data-revslider-track]");
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll(".lm-revcard"));
    if (cards.length < 2) return;

    var prev = wrap.querySelector("[data-revslider-prev]");
    var next = wrap.querySelector("[data-revslider-next]");
    var dotsWrap = wrap.querySelector("[data-revslider-dots]");
    var dots = [];

    function step() {
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function index() {
      return Math.round(track.scrollLeft / step());
    }

    function goTo(i) {
      track.scrollTo({ left: Math.max(0, i) * step(), behavior: "smooth" });
    }

    if (dotsWrap) {
      cards.forEach(function (card, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "lm-revslider__dot";
        dot.setAttribute("aria-label", "Review " + (i + 1) + " of " + cards.length);
        dot.addEventListener("click", function () { goTo(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function sync() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      /* At the far right the track cannot scroll the last card to the start,
         so the derived index stops short and the final dot never lights up.
         Pin it when we are actually at the end. */
      var i = atEnd ? cards.length - 1 : index();
      dots.forEach(function (dot, n) { dot.classList.toggle("is-active", n === i); });
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    if (prev) prev.addEventListener("click", function () { goTo(index() - 1); });
    if (next) next.addEventListener("click", function () { goTo(index() + 1); });

    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    });
    window.addEventListener("resize", sync);
    sync();
  });

  /* ---------- Frequently bought together bundle ---------- */
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var wrap = bundle.closest('.lm-bundle');
    var totalEl = wrap.querySelector('[data-bundle-total]');
    var compareEl = wrap.querySelector('[data-bundle-compare]');
    var saveEl = wrap.querySelector('[data-bundle-save]');
    var countEl = wrap.querySelector('[data-bundle-count]');
    var addBtn = wrap.querySelector('[data-bundle-add]');
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
    function bundleDiscountRate(count) {
      if (count >= 4) return 0.20;
      if (count === 3) return 0.15;
      if (count === 2) return 0.10;
      return 0;
    }
    function recalc() {
      var total = 0, count = 0;
      bundle.querySelectorAll('[data-bundle-item]').forEach(function (item) {
        var toggle = item.querySelector('[data-bundle-toggle]');
        if (toggle.classList.contains('is-checked')) {
          total += parseInt(item.getAttribute('data-price'), 10);
          count += 1;
        }
      });
      var rate = bundleDiscountRate(count);
      var discounted = Math.round(total * (1 - rate));
      if (totalEl) totalEl.textContent = formatMoney(discounted);
      if (countEl) countEl.textContent = count;
      if (compareEl) {
        if (rate > 0) { compareEl.textContent = formatMoney(total); compareEl.removeAttribute('hidden'); }
        else compareEl.setAttribute('hidden', '');
      }
      if (saveEl) {
        if (rate > 0) { saveEl.textContent = 'Extra ' + Math.round(rate * 100) + '% off applied'; saveEl.removeAttribute('hidden'); }
        else saveEl.setAttribute('hidden', '');
      }
    }
    bundle.querySelectorAll('[data-bundle-toggle]:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-checked');
        recalc();
      });
    });
    bundle.querySelectorAll('[data-bundle-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('[data-bundle-item]');
        var option = sel.options[sel.selectedIndex];
        var priceCents = parseInt(option.getAttribute('data-price'), 10);
        item.setAttribute('data-price', priceCents);
        var priceEl = item.querySelector('[data-bundle-price]');
        if (priceEl) priceEl.textContent = formatMoney(priceCents);
        var variantInput = item.querySelector('[data-bundle-variant]');
        if (variantInput) variantInput.value = option.value;
        var imgUrl = option.getAttribute('data-image');
        var imgEl = item.querySelector('.lm-bundle__imgwrap img');
        if (imgEl && imgUrl) {
          imgEl.removeAttribute('srcset');
          imgEl.removeAttribute('sizes');
          imgEl.src = imgUrl;
        }
        recalc();
      });
    });
    function collectItems() {
      var items = [];
      bundle.querySelectorAll('[data-bundle-item]').forEach(function (item) {
        var toggle = item.querySelector('[data-bundle-toggle]');
        if (!toggle.classList.contains('is-checked')) return;
        var variantInput = item.querySelector('[data-bundle-variant]');
        var variantId = variantInput ? variantInput.value : (document.querySelector('[data-variant-select]') || {}).value;
        if (variantId) items.push({ id: variantId, quantity: 1 });
      });
      return items;
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = collectItems();
        if (!items.length) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (r.ok && window.LMToast) window.LMToast('Added to cart');
          if (window.LMCart) window.LMCart.refresh().then(function () { window.LMCart.open(); });
        });
      });
    }
    var buyNowBtn = wrap.querySelector('[data-bundle-buynow]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var items = collectItems();
        if (!items.length) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (r.ok) window.location.href = '/checkout';
        });
      });
    }
    recalc();
  });

  /* ---------- Accordions (Contact FAQ, PDP details, etc.) ---------- */
  /* The CSS opens these by animating max-height to a fixed ceiling, which
     silently clips any panel taller than that ceiling — a merchant-supplied
     size table in the product description is long enough to hit it. So the
     open height is measured from the content instead, and dropped to `none`
     once the animation ends: images and webfonts that settle afterwards can
     then grow the panel without being cut off. */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var toggle = acc.querySelector('[data-accordion-toggle]');
    var body = acc.querySelector('.lm-accordion__body');
    if (!toggle || !body) return;

    function release() {
      if (acc.classList.contains('is-open')) body.style.maxHeight = 'none';
    }
    body.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height') release();
    });

    if (acc.classList.contains('is-open')) body.style.maxHeight = 'none';

    toggle.addEventListener('click', function () {
      if (acc.classList.contains('is-open')) {
        /* Pin the current height first so the collapse has something to
           animate away from — a transition out of `none` does not run. */
        body.style.maxHeight = body.scrollHeight + 'px';
        void body.offsetHeight;
        acc.classList.remove('is-open');
        body.style.maxHeight = '';
      } else {
        acc.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Collection filter sheet (phones) ----------
     Opens the same GET form the desktop toolbar submits, so there is one
     filtering path rather than two that can drift apart. Without the script
     the sheet simply never opens and the desktop selects still work. */
  (function initFilterSheet() {
    var sheet = document.querySelector('[data-filtersheet]');
    var backdrop = document.querySelector('[data-filtersheet-backdrop]');
    var openBtn = document.querySelector('[data-filtersheet-open]');
    if (!sheet || !backdrop || !openBtn) return;

    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      sheet.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = sheet.querySelector('select, button, a');
      if (first) first.focus();
    }
    function close() {
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    sheet.querySelectorAll('[data-filtersheet-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
    });

    // An empty select would otherwise submit an empty param and leave a
    // stray ?filter.p.x= on every filtered URL.
    var form = sheet.querySelector('[data-filtersheet-form]');
    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('select').forEach(function (sel) {
          if (!sel.value) sel.disabled = true;
        });
      });
    }
  })();

  /* ---------- PDP ---------- */
  var pdp = document.querySelector('[data-product-section]');
  if (pdp) initProduct(pdp);

  function initProduct(root) {
    var variantsScript = document.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}

    var form = root.querySelector('[data-product-form]');
    var select = root.querySelector('[data-variant-select]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var addText = root.querySelector('[data-add-text]');
    var addButton = root.querySelector('[data-add-button]');
    var selectedColorEl = root.querySelector('[data-selected-color]');
    var mainImage = root.querySelector('[data-main-image]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    var selectedOptions = [];
    root.querySelectorAll('[data-option-button].is-active').forEach(function (btn) {
      selectedOptions[parseInt(btn.getAttribute('data-option-position'), 10) - 1] = btn.getAttribute('data-value');
    });

    function findVariant() {
      // Nothing to choose: there is one variant and it is the one.
      if (optionCount === 0) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var fmt = window.lmTheme && window.lmTheme.moneyFormat;
      if (fmt && fmt.indexOf('{{') > -1) {
        return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }
      return '$' + amount;
    }

    // Real inventory, handed over separately because Shopify omits it from
    // the variant JSON. A variant missing from this map is one Shopify is not
    // tracking, and gets no claim made about it.
    var voorraad = {};
    try {
      var voorraadEl = root.querySelector('[data-stock-json]') || document.querySelector('[data-stock-json]');
      if (voorraadEl) voorraad = JSON.parse(voorraadEl.textContent) || {};
    } catch (e) { voorraad = {}; }
    function voorraadVan(id) {
      var n = voorraad[String(id)];
      return (typeof n === 'number') ? n : null;
    }

    var stockLine = root.querySelector('[data-stock-line]');
    var stockLineText = root.querySelector('[data-stock-line-text]');
    var stockLineTemplate = (stockLine && stockLine.getAttribute('data-stock-line')) || 'Only [count] pairs left in stock.';

    // Derived from the variant id, not random: the same colour/size shows the
    // same figure on every page and every visit, so a shopper who goes back and
    // forth never catches the number changing.
    //
    // Hashed through a prime first. Variant ids inside one product are handed
    // out in fixed-size blocks, so `id % 8` on its own returns the same value
    // for every variant — the whole product ends up claiming one number.
    // The invented stock figure is gone. It returned 2 + (id % 8) — a number
    // between two and nine that had nothing to do with inventory, printed
    // directly above a bar showing the real count. The line now reads that
    // same real number, handed over by the template.

    function renderStockLine(variant) {
      if (!stockLine || !stockLineText) return;
      if (!variant || !variant.available) { stockLine.hidden = true; return; }
      // Only worth saying when it is nearly gone. "Only 40 left" is padding,
      // and a figure the template could not supply is not shown at all.
      var drempel = parseInt(stockLine.getAttribute('data-stock-threshold'), 10) || 0;
      var echt = voorraadVan(variant.id);
      if (echt == null || echt <= 0 || (drempel > 0 && echt > drempel)) { stockLine.hidden = true; return; }
      // [item] resolves per product (" pairs" on footwear, empty elsewhere), so
      // a dress never claims to come in pairs.
      var itemWord = (stockLine.getAttribute('data-stock-item') || '');
      var filled = stockLineTemplate.split('[item]').join(itemWord);
      var parts = filled.split('[count]');
      stockLineText.textContent = '';
      stockLineText.appendChild(document.createTextNode(parts[0] || ''));
      var strong = document.createElement('strong');
      strong.textContent = voorraadVan(variant.id);
      stockLineText.appendChild(strong);
      stockLineText.appendChild(document.createTextNode(parts.length > 1 ? parts[1] : ''));
      stockLine.hidden = false;
    }

    var optionCount = (variants[0] && variants[0].options && variants[0].options.length) || 0;
    var optionNames = [];
    var optieKnoppen = root.querySelectorAll('[data-option-button]');
    optieKnoppen.forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10) - 1;
      if (!optionNames[pos]) optionNames[pos] = btn.getAttribute('data-option-name') || 'option';
    });
    // A piece with no real choices still reports one option -- Shopify's own
    // 'Default Title' -- but the section renders no picker for it. Counting it
    // left the button waiting forever on a choice that does not exist, which
    // is what put 'Select A Option' on the bracelets and the necklace.
    if (optieKnoppen.length === 0) optionCount = 0;

    // isInitial = the call made while the page is loading. On that pass the
    // gallery and URL are left alone, so the product's own first photo stays
    // put instead of jumping to whichever colour happens to come first.
    // Writes the chosen value beside the option name. Called from here so it
    // covers a click, a preselect and a variant switch alike.
    function toonKeuzes() {
      root.querySelectorAll('[data-selected-value]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-option-position'), 10) - 1;
        var waarde = selectedOptions[pos];
        el.textContent = waarde ? ': ' + waarde : '';
        el.classList.toggle('is-chosen', !!waarde);
      });
    }

    function updateVariant(isInitial) {
      toonKeuzes();
      for (var i = 0; i < optionCount; i++) {
        if (!selectedOptions[i]) {
          // 'Select A Option' was both cold and ungrammatical. Warmer, and it
          // reads correctly whatever the option is called.
          if (addText) {
            var watNog = (optionNames[i] || '').toLowerCase();
            addText.textContent = watNog ? 'Choose your ' + watNog + ' first' : 'Choose your option first';
          }
          // Marked, not disabled. A disabled button swallows the click, so
          // someone who reads "Select a ring size" and presses it gets nothing:
          // no sizes, no explanation, a dead control. It stays pressable and
          // sends them to the row it is asking about; the submit handler still
          // refuses while nothing is chosen.
          if (addButton) {
            addButton.disabled = false;
            addButton.classList.add('is-awaiting-option');
            addButton.setAttribute('data-awaiting-position', String(i + 1));
          }
          renderStockLine(null);
          return;
        }
      }
      if (addButton) {
        addButton.classList.remove('is-awaiting-option');
        addButton.removeAttribute('data-awaiting-position');
      }
      var variant = findVariant();
      if (!variant) {
        if (addText) addText.textContent = 'Unavailable';
        if (addButton) addButton.disabled = true;
        renderStockLine(null);
        return;
      }
      renderStockLine(variant);
      if (select) select.value = variant.id;

      // A zero price says the merchant's wording, not "$0.00" — matching what
      // the page rendered server-side, so switching variants cannot make the
      // price look broken.
      var priceBlock = root.querySelector('[data-price-block]');
      var zeroLabel = (priceBlock && priceBlock.getAttribute('data-zero-label')) || 'Free';
      var isFree = variant.price === 0;
      var priceStr = isFree ? zeroLabel : formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceStr;
      if (priceEl) priceEl.classList.toggle('lm-pdp__price--free', isFree);
      if (priceBlock) priceBlock.classList.toggle('lm-pdp__pricerow--free', isFree);
      if (stickyPrice) stickyPrice.textContent = priceStr;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false; }
        // The cash figure rather than the percentage — on a free piece the
        // percentage only restates the zero.
        if (saveEl) { saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); saveEl.hidden = false; }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? ('Add to Cart · ' + priceStr) : 'Sold Out';

      if (!isInitial && variant.featured_media && window.LMGalleryGoToMedia) {
        window.LMGalleryGoToMedia(variant.featured_media.id);
      }
      // Swap gallery to the variant's featured media
      if (!isInitial && variant.featured_media && mainImage) {
        var src = variant.featured_media.preview_image && variant.featured_media.preview_image.src;
        if (src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = src.replace(/(\.[^.?]*)(\?|$)/, '_1000x$1$2');
        }
      }

      // Update URL for shareability without reloading
      if (!isInitial && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-button]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10) - 1;
        selectedOptions[pos] = btn.getAttribute('data-value');
        // toggle active state among siblings
        btn.parentNode.querySelectorAll('[data-option-button]').forEach(function (sib) { sib.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariant();
      });
    });

    // Preselecting the first value, where the merchant has asked for it.
    // Done by writing into selectedOptions rather than clicking the buttons,
    // so the initial pass still leaves the gallery and the URL alone and the
    // product's own first photograph stays put.
    //
    // 'except-size' is the default on purpose: a finish is a preference and a
    // sensible default costs nothing, but a ring size is a measurement. With
    // a size already ticked someone can check out without ever choosing one,
    // and a ring that does not fit comes back as a resize Lucy pays for.
    (function voorkiezen() {
      var stand = (root.getAttribute('data-preselect') || 'except-size');
      if (stand === 'none') return;
      for (var p = 0; p < optionCount; p++) {
        if (selectedOptions[p]) continue;
        var naam = (optionNames[p] || '').toLowerCase();
        if (stand === 'except-size' && naam.indexOf('size') > -1) continue;
        var knop = root.querySelector('[data-option-button][data-option-position="' + (p + 1) + '"]:not([disabled]):not(.is-unavailable)');
        if (knop) {
          selectedOptions[p] = knop.getAttribute('data-value');
          knop.classList.add('is-active');
          root.querySelectorAll('[data-option-button][data-option-position="' + (p + 1) + '"]').forEach(function (b) {
            if (b !== knop) b.classList.remove('is-active');
          });
        }
      }
    })();

    updateVariant(true);

    /* Quantity */
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    });
    root.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    });

    /* Gallery thumbs + next */
    var thumbs = root.querySelectorAll('[data-thumb]');
    var galleryIndex = 0;
    function showThumb(i) {
      var thumb = thumbs[i];
      if (!thumb) return;
      var fullSrc = thumb.getAttribute('data-full-src');
      if (fullSrc && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = fullSrc;
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      galleryIndex = i;
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showThumb(i); });
    });
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { showThumb((galleryIndex + 1) % thumbs.length); });

    /* Phones: move the title, rating and price above the gallery so the price is
       visible without scrolling. The nodes are moved, not restyled, and they go
       back where they came from if the viewport widens again. */
    (function initMobileOrder() {
      var pdp = root.classList && root.classList.contains('lm-pdp') ? root : root.querySelector('.lm-pdp');
      var gallery = pdp && pdp.querySelector('.lm-gallery');
      if (!pdp || !gallery) return;

      // insertBefore wants a direct child of pdp as its reference, and the
      // gallery is not one - it sits inside .lm-pdp__media. Passing the
      // gallery itself threw NotFoundError on the first node and aborted the
      // whole reorder, so on a phone the title, rating and price never moved
      // above the photographs. Walk up to the child that actually belongs to
      // pdp and use that as the anchor instead.
      var anchor = gallery;
      while (anchor && anchor.parentNode !== pdp) anchor = anchor.parentNode;
      if (!anchor) return;
      var nodes = ['.lm-pdp__title', '.lm-pdp__reviews-link', '.lm-pdp__pricerow']
        .map(function (s) { return pdp.querySelector(s); })
        .filter(Boolean);
      if (!nodes.length) return;
      nodes.forEach(function (n) {
        n._homeParent = n.parentNode;
        n._homeNext = n.nextSibling;
        n._homeIndex = Array.prototype.indexOf.call(n.parentNode.children, n);
      });

      // On a phone the stock line costs a whole row of its own between the
      // sizes and the Add to Cart. Sitting on the SIZE label row instead it
      // costs nothing and lifts the button. Desktop has the room, so it stays
      // where it is there.
      var stock = pdp.querySelector('.lm-stockline');
      var sizeRow = pdp.querySelector('.lm-size-row');
      var sizeLabel = sizeRow && sizeRow.previousElementSibling;
      if (sizeLabel && !sizeLabel.classList.contains('lm-option-label')) sizeLabel = null;
      if (stock) { stock._homeParent = stock.parentNode; stock._homeNext = stock.nextSibling; }

      // insertBefore throws when the reference node is no longer a child of the
      // parent — which happens as soon as anything else has touched the DOM in
      // between. The throw aborted the rest of this block, so it is guarded and
      // falls back to putting the node back at the end of its original parent.
      function putBack(n) {
        if (!n || !n._homeParent) return;
        function atIndex() {
          var ref = n._homeParent.children[n._homeIndex] || null;
          n._homeParent.insertBefore(n, ref);
        }
        try {
          if (n._homeNext && n._homeNext.parentNode === n._homeParent) {
            n._homeParent.insertBefore(n, n._homeNext);
          } else {
            atIndex();
          }
        } catch (e) {
          try { atIndex(); } catch (e2) { n._homeParent.appendChild(n); }
        }
      }

      var mq = window.matchMedia('(max-width: 859px)');
      function apply() {
        var narrow = mq.matches;
        var moved = pdp.classList.contains('lm-pdp--reordered');
        if (narrow && !moved) {
          nodes.forEach(function (n) {
            try { pdp.insertBefore(n, anchor); } catch (e) { pdp.insertBefore(n, pdp.firstChild); }
          });
          if (stock && sizeLabel) {
            sizeLabel.appendChild(stock);
            sizeLabel.classList.add('lm-option-label--with-stock');
          }
          pdp.classList.add('lm-pdp--reordered');
        } else if (!narrow && moved) {
          // Last node first: each one's reference sibling is a node that moved too,
          // so restoring front to back left every reference still displaced and
          // dropped the title at the end of the column.
          nodes.slice().reverse().forEach(putBack);
          if (stock && sizeLabel) {
            putBack(stock);
            sizeLabel.classList.remove('lm-option-label--with-stock');
          }
          pdp.classList.remove('lm-pdp--reordered');
        }
      }
      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);
    })();

    /* Phone gallery carousel: dots, and a jump to the right photo when a
       colour is chosen. Desktop keeps the thumbnail rail and never runs this. */
    (function initMobileGallery() {
      var wrap = root.querySelector('[data-gallery-mobile]');
      var track = root.querySelector('[data-gallery-slides]');
      var dotsWrap = root.querySelector('[data-gallery-dots]');
      if (!wrap || !track || !dotsWrap) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.lm-gallery__slide'));
      if (slides.length < 2) { dotsWrap.style.display = 'none'; return; }

      // A product with ten colours ends up with a dozen photos, and a dozen
      // dots is a smear rather than a control. Past eight, show "3 / 13".
      var useCounter = slides.length > 8;
      var counter = null;
      var dots = [];
      if (useCounter) {
        dotsWrap.classList.add('lm-gallery__dots--counter');
        counter = document.createElement('span');
        counter.className = 'lm-gallery__counter';
        dotsWrap.appendChild(counter);
      } else {
        slides.forEach(function (s, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'lm-gallery__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Show image ' + (i + 1));
          d.addEventListener('click', function () {
            track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: 'smooth' });
          });
          dotsWrap.appendChild(d);
        });
        dots = Array.prototype.slice.call(dotsWrap.children);
      }

      // Nearest slide to the centre of the viewport wins, because snapping to
      // centre means no slide ever sits flush with the left edge.
      function syncDots() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(c - mid);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        if (counter) counter.textContent = (best + 1) + ' / ' + slides.length;
        else dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      }
      track.addEventListener('scroll', function () {
        window.clearTimeout(track._dotTimer);
        track._dotTimer = window.setTimeout(syncDots, 60);
      }, { passive: true });
      syncDots();

      // Picking a colour should move the carousel to that colour's photo.
      window.LMGalleryGoToMedia = function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
            track.scrollTo({ left: slides[i].offsetLeft - (track.clientWidth - slides[i].clientWidth) / 2, behavior: 'smooth' });
            return;
          }
        }
      };
    })();

    /* How far down the photo column sticks. A column shorter than the window
       hangs under the header; one that is taller has to stick to the bottom of
       the window instead, or the last photos sit below the fold forever and no
       amount of scrolling brings them up. */
    (function initPlakkendeFotos() {
      var kolom = root.querySelector('.lm-pdp__media--mosaic');
      if (!kolom) return;
      var meet = function () {
        if (window.innerWidth < 860) { kolom.style.removeProperty('--lm-media-top'); return; }
        var hoogte = kolom.getBoundingClientRect().height;
        var top = Math.min(110, window.innerHeight - hoogte - 24);
        kolom.style.setProperty('--lm-media-top', Math.round(top) + 'px');
      };
      meet();
      window.addEventListener('resize', meet, { passive: true });
      // Every photo that arrives changes the height the offset was based on.
      kolom.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', meet);
      });
    })();

    /* Desktop mosaic: every photo is already on screen, so picking a colour
       has nothing to swap. It only has to bring that colour's photo into view,
       and only when that photo is not already in view - scrolling the page out
       from under someone who is reading the description is worse than letting
       them find the photo themselves. */
    (function initMosaic() {
      var mosaic = root.querySelector('[data-gallery-mosaic]');
      if (!mosaic) return;
      var tegels = Array.prototype.slice.call(mosaic.querySelectorAll('[data-media-id]'));
      var vorige = window.LMGalleryGoToMedia;
      window.LMGalleryGoToMedia = function (mediaId) {
        if (vorige) vorige(mediaId);
        // offsetParent is null while the mosaic is hidden, which is every phone.
        if (!mediaId || !mosaic.offsetParent) return;
        for (var i = 0; i < tegels.length; i++) {
          if (tegels[i].getAttribute('data-media-id') !== String(mediaId)) continue;
          var doos = tegels[i].getBoundingClientRect();
          if (doos.top < 90 || doos.bottom > window.innerHeight) {
            tegels[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
      };
    })();

    /* Thumbnail rail scroll (up/down), capped to the main image's height.
       Height is set from JS (not CSS stretch) so the thumb column can never
       inflate the main image's own aspect-ratio sizing. */
    var thumbTrack = root.querySelector('[data-thumb-track]');
    var thumbUp = root.querySelector('[data-thumb-scroll-up]');
    var thumbDown = root.querySelector('[data-thumb-scroll-down]');
    var thumbCol = root.querySelector('.lm-gallery__thumbcol');
    if (thumbTrack && thumbUp && thumbDown && thumbCol && mainImage) {
      function matchThumbColHeight() {
        var gallery = root.querySelector('.lm-gallery');
        if (gallery && getComputedStyle(gallery).flexDirection !== 'row') {
          thumbCol.style.height = '';
          return;
        }
        var h = mainImage.closest('.lm-gallery__main').getBoundingClientRect().height;
        if (h > 0) thumbCol.style.height = h + 'px';
      }
      function isHorizontal() {
        return getComputedStyle(thumbCol).flexDirection === 'row';
      }
      function updateThumbScrollUI() {
        var needed = isHorizontal()
          ? thumbTrack.scrollWidth > thumbTrack.clientWidth + 1
          : thumbTrack.scrollHeight > thumbTrack.clientHeight + 1;
        thumbUp.classList.toggle('is-needed', needed);
        thumbDown.classList.toggle('is-needed', needed);
      }
      var thumbStep = function () {
        var first = thumbTrack.querySelector('[data-thumb]');
        if (!first) return 100;
        var rect = first.getBoundingClientRect();
        return (isHorizontal() ? rect.width : rect.height) + 8;
      };
      // Keeps the chosen thumbnail inside the rail without moving the page:
      // scrollIntoView would happily scroll the window as well.
      function revealThumb(thumb) {
        if (!thumb) return;
        var rail = thumbTrack.getBoundingClientRect();
        var t = thumb.getBoundingClientRect();
        if (isHorizontal()) {
          if (t.left < rail.left) thumbTrack.scrollBy({ left: t.left - rail.left - 4, behavior: 'smooth' });
          else if (t.right > rail.right) thumbTrack.scrollBy({ left: t.right - rail.right + 4, behavior: 'smooth' });
        } else {
          if (t.top < rail.top) thumbTrack.scrollBy({ top: t.top - rail.top - 4, behavior: 'smooth' });
          else if (t.bottom > rail.bottom) thumbTrack.scrollBy({ top: t.bottom - rail.bottom + 4, behavior: 'smooth' });
        }
      }
      // The arrows move the selection, not just the rail: clicking down while
      // the main image stayed put made the arrows feel broken. Wraps around at
      // both ends so the rail keeps turning.
      function stepGallery(dir) {
        if (!thumbs.length) return;
        var next = galleryIndex + dir;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        showThumb(next);
        revealThumb(thumbs[next]);
      }
      thumbUp.addEventListener('click', function () { stepGallery(-1); });
      thumbDown.addEventListener('click', function () { stepGallery(1); });
      window.addEventListener('resize', function () { matchThumbColHeight(); updateThumbScrollUI(); });
      matchThumbColHeight();
      updateThumbScrollUI();
      if (mainImage.complete) { matchThumbColHeight(); updateThumbScrollUI(); }
      else mainImage.addEventListener('load', function () { matchThumbColHeight(); updateThumbScrollUI(); });
    }

    /* Read more clamp */
    root.querySelectorAll('[data-clamp-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var clamp = btn.parentNode.querySelector('[data-clamp]');
        if (!clamp) return;
        var isClamped = clamp.classList.toggle('lm-clamp');
        btn.textContent = isClamped ? 'Read more' : 'Show less';
      });
    });

    /* Ship-by date: today + 2 business days, skipping Sunday */
    var shipEl = root.querySelector('[data-ship-by]');
    if (shipEl) shipEl.textContent = computeShipBy();

    /* Sticky add-to-cart bar */
    // Pressing the button while it still asks for a size takes the shopper to
    // that row and marks it, instead of leaving them on a control that does
    // nothing.
    if (addButton) {
      addButton.addEventListener('click', function (e) {
        if (!addButton.classList.contains('is-awaiting-option')) return;
        e.preventDefault();
        var rij = root.querySelector('.lm-size-row') || root.querySelector('[data-option-button]');
        if (!rij) return;
        var doel = rij.closest('.lm-option-group') || rij;
        doel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        doel.classList.add('lm-option-attention');
        setTimeout(function () { doel.classList.remove('lm-option-attention'); }, 1800);
      });
    }

    var stickyBar = document.querySelector('[data-sticky-add]');
    var ctaRow = root.querySelector('.lm-cta-row');
    // The bar appears once the gallery has scrolled out of view, not merely
    // once the Add to Cart button has: while the photo is still on screen the
    // shopper is looking at the product, and a bar over it is in the way.
    var gallerySection = root.querySelector('.lm-gallery');
    if (stickyBar && (ctaRow || gallerySection)) {
      // Both the gallery and the real Add to Cart button have to be off screen.
      // On phones the button now sits below the photo, so watching the gallery
      // alone made the bar appear while the actual button was still in view —
      // two Add to Cart controls arguing on one screen.
      window.addEventListener('scroll', function () {
        var galleryGone = !gallerySection || gallerySection.getBoundingClientRect().bottom < 0;
        var ctaGone = !ctaRow || ctaRow.getBoundingClientRect().bottom < 0;
        stickyBar.classList.toggle('is-visible', galleryGone && ctaGone);
      }, { passive: true });
      var stickyBtn = stickyBar.querySelector('[data-sticky-add-button]');
      // The bar used to read "Add to Cart" and stay live while the real button
      // was still asking for a size: two controls disagreeing about whether the
      // piece could be bought. It mirrors the button it stands in for now.
      if (stickyBtn) {
        var stickyLabel = stickyBtn.textContent.trim();
        var spiegel = function () {
          var wacht = addButton && addButton.classList.contains('is-awaiting-option');
          stickyBtn.textContent = wacht && addText ? addText.textContent : stickyLabel;
          stickyBtn.classList.toggle('is-awaiting-option', !!wacht);
        };
        spiegel();
        if (addButton && window.MutationObserver) {
          new MutationObserver(spiegel).observe(addButton, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true, characterData: true });
        }
        stickyBtn.addEventListener('click', function () {
          if (addButton && addButton.classList.contains('is-awaiting-option')) { addButton.click(); return; }
          if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[data-add-button]').click();
        });
      }

      stickyBar.querySelectorAll('[data-sticky-option]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var pos = sel.getAttribute('data-option-position');
          var value = sel.value;
          var mainBtn = root.querySelector('[data-option-button][data-option-position="' + pos + '"][data-value="' + CSS.escape(value) + '"]');
          if (mainBtn) mainBtn.click();
        });
      });

      var priceEl = stickyBar.querySelector('[data-sticky-price]');
      var origUpdateVariant = updateVariant;
      updateVariant = function () {
        origUpdateVariant();
        stickyBar.querySelectorAll('[data-sticky-option]').forEach(function (sel) {
          var pos = sel.getAttribute('data-option-position');
          var active = root.querySelector('[data-option-button][data-option-position="' + pos + '"].is-active');
          if (active) sel.value = active.getAttribute('data-value');
        });
        var priceNow = root.querySelector('[data-price]');
        if (priceEl && priceNow) priceEl.textContent = priceNow.textContent;
      };
    }
  }

  function computeShipBy() {
    var d = new Date();
    var added = 0;
    while (added < 2) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sunday
    }
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* ---------- Account drawer ---------- */
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('[data-account-drawer]');
    var backdrop = document.querySelector('[data-account-backdrop]');
    if (e.target.closest('[data-account-toggle]')) {
      if (drawer) drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
    }
    if (e.target.closest('[data-account-close]') || e.target.closest('[data-account-backdrop]')) {
      if (drawer) drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }
    // account tabs
    var tab = e.target.closest('[data-account-tab]');
    if (tab) {
      document.querySelectorAll('[data-account-tab]').forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var mode = tab.getAttribute('data-account-tab');
      document.querySelectorAll('[data-account-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-account-panel') !== mode;
      });
    }
  });

  /* ---------- Color swatch row slide hint (mobile) ---------- */
  (function initSwatchRowSlideHint() {
    document.querySelectorAll('.lm-swatch-row').forEach(function (row) {
      if (row.nextElementSibling && row.nextElementSibling.classList.contains('lm-scroll-track')) return;
      var track = document.createElement('div');
      track.className = 'lm-scroll-track';
      var thumb = document.createElement('div');
      thumb.className = 'lm-scroll-thumb';
      track.appendChild(thumb);
      row.insertAdjacentElement('afterend', track);

      function update() {
        var overflow = row.scrollWidth > row.clientWidth + 2;
        track.classList.toggle('is-needed', overflow);
        if (!overflow) return;
        var ratio = row.clientWidth / row.scrollWidth;
        var maxScroll = row.scrollWidth - row.clientWidth;
        var left = maxScroll > 0 ? (row.scrollLeft / maxScroll) * (100 - ratio * 100) : 0;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.left = left + '%';
      }
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  /* ---------- Product card swatch hover preview ---------- */
  (function initCardSwatchPreview() {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest('[data-swatch-preview]');
      if (!dot) return;
      var card = dot.closest('.lm-card');
      var img = card && card.querySelector('[data-card-main-img]');
      var previewSrc = dot.getAttribute('data-swatch-img');
      if (!img || !previewSrc || img.src === previewSrc) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = previewSrc;
    });
    document.addEventListener('mouseout', function (e) {
      var dot = e.target.closest('[data-swatch-preview]');
      if (!dot) return;
      var card = dot.closest('.lm-card');
      if (card && card.contains(e.relatedTarget)) return;
      var img = card && card.querySelector('[data-card-main-img]');
      var defaultSrc = img && img.getAttribute('data-default-src');
      if (!img || !defaultSrc || img.src === defaultSrc) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = defaultSrc;
    });
  })();

  /* ---------- Reviews: write-a-review modal ---------- */
  (function initReviewsDrawer() {
    var backdrop = document.querySelector('[data-reviews-drawer-backdrop]');
    var drawer = document.querySelector('[data-reviews-drawer]');
    if (!drawer) return;

    function open() { drawer.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-reviews-drawer-open]')) open();
      if (e.target.closest('[data-reviews-drawer-close]') || e.target.closest('[data-reviews-drawer-backdrop]')) close();
    });

    var searchInput = drawer.querySelector('[data-reviews-search]');
    var items = drawer.querySelectorAll('[data-reviews-drawer-item]');
    var empty = drawer.querySelector('[data-reviews-drawer-empty]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim().toLowerCase();
        var visibleCount = 0;
        items.forEach(function (item) {
          var match = !q || item.getAttribute('data-search-text').indexOf(q) > -1;
          item.hidden = !match;
          if (match) visibleCount++;
        });
        if (empty) empty.hidden = visibleCount > 0;
      });
    }

    var sortSelect = drawer.querySelector('[data-reviews-sort]');
    var list = drawer.querySelector('[data-reviews-drawer-list]');
    if (sortSelect && list) {
      sortSelect.addEventListener('change', function () {
        var nodes = Array.prototype.slice.call(list.querySelectorAll('[data-reviews-drawer-item]'));
        if (sortSelect.value === 'oldest') nodes.reverse();
        nodes.forEach(function (n) { list.appendChild(n); });
      });
    }
  })();

  /* ---------- Inline review search/sort (above the main review grid) ---------- */
  (function initInlineReviews() {
    var grid = document.querySelector('[data-reviews-inline-grid]');
    if (!grid) return;
    var searchInput = document.querySelector('[data-reviews-inline-search]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim().toLowerCase();
        grid.querySelectorAll('.lm-review-card').forEach(function (card) {
          var match = !q || (card.getAttribute('data-search-text') || '').indexOf(q) > -1;
          card.style.display = match ? '' : 'none';
        });
      });
    }
    var sortBtn = document.querySelector('[data-reviews-inline-sort]');
    if (sortBtn) {
      var reversed = false;
      sortBtn.addEventListener('click', function () {
        reversed = !reversed;
        sortBtn.childNodes[0].textContent = reversed ? 'Oldest first ' : 'Sort by date ';
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.lm-review-card'));
        cards.reverse();
        cards.forEach(function (c) { grid.appendChild(c); });
      });
    }
  })();

  /* ---------- Size chart modal ---------- */
  (function initSizeChartModal() {
    var backdrop = document.querySelector('[data-size-chart-backdrop]');
    var modal = document.querySelector('[data-size-chart-modal]');
    if (!modal) return;

    function open() { modal.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); }
    function close() { modal.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-chart-open]')) open();
      if (e.target.closest('[data-size-chart-close]') || e.target === backdrop) close();
    });
  })();

  /* ---------- Review photo lightbox ---------- */
  (function initReviewPhotoLightbox() {
    // Review photos are deliberately not enlargeable — they are proof on the
    // card, not a gallery to browse. The lightbox stays in place for any other
    // photo that opts in with .lm-lightbox-photo.
    // The cart draws its lines after this runs, so an empty page still has to
    // set the lightbox up when there is a cart drawer to open it from.
    if (!document.querySelector('.lm-lightbox-photo') && !document.querySelector('[data-cart-drawer]')) return;

    var backdrop = document.createElement('div');
    backdrop.className = 'lm-modal-backdrop lm-photo-lightbox-backdrop';
    var modal = document.createElement('div');
    modal.className = 'lm-photo-lightbox';
    modal.innerHTML = '<button type="button" class="lm-modal__close" data-lightbox-close aria-label="Close">&times;</button><img data-lightbox-img src="" alt="">';
    document.body.appendChild(backdrop);
    document.body.appendChild(modal);
    var img = modal.querySelector('[data-lightbox-img]');

    function open(src, alt) {
      img.src = src;
      img.alt = alt || '';
      backdrop.classList.add('is-open');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      backdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      // Closing a photo opened from inside the cart must not hand the page
      // back its scrollbar: the drawer is still open over it.
      var cartOpen = document.querySelector('[data-cart-drawer].is-open');
      document.body.style.overflow = cartOpen ? 'hidden' : '';
      img.src = '';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.lm-lightbox-photo');
      if (trigger) {
        open(trigger.getAttribute('data-full-src') || trigger.src, trigger.alt);
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === backdrop) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('lm-lightbox-photo')) {
        e.preventDefault();
        open(e.target.getAttribute('data-full-src') || e.target.src, e.target.alt);
      }
    });
  })();

  /* ---------- Review cards: "See more" only when text actually overflows ---------- */
  (function initReviewSeeMore() {
    document.querySelectorAll('.lm-review-card').forEach(function (card) {
      var text = card.querySelector('[data-clamp]');
      var btn = card.querySelector('[data-review-seemore]');
      if (!text || !btn) return;
      if (text.scrollHeight > text.clientHeight + 1) btn.classList.add('is-visible');
      btn.addEventListener('click', function () {
        var expanded = !text.classList.toggle('lm-clamp');
        btn.textContent = expanded ? 'See less' : 'See more';
      });
    });
  })();

  (function initReviews() {
    var backdrop = document.querySelector('[data-review-backdrop]');
    var modal = document.querySelector('[data-review-modal]');
    if (!modal) return;

    function openModal() { modal.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); }
    function closeModal() { modal.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-write-review-open]')) openModal();
      if (e.target.closest('[data-write-review-close]') || e.target.closest('[data-review-backdrop]')) closeModal();
    });

    /* Reopen the modal already showing "thank you" after Shopify's contact
       form redirects back post-submit. */
    if (modal.querySelector('[data-review-thanks]:not([hidden])')) openModal();

    var rating = 5;
    var stars = modal.querySelectorAll('[data-star-value]');
    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        rating = parseInt(star.getAttribute('data-star-value'), 10);
        stars.forEach(function (s) {
          s.classList.toggle('is-lit', parseInt(s.getAttribute('data-star-value'), 10) <= rating);
        });
      });
    });

    var form = modal.querySelector('form');
    var hiddenBody = modal.querySelector('[data-review-hidden-body]');
    if (form && hiddenBody) {
      form.addEventListener('submit', function (e) {
        var text = modal.querySelector('[data-review-text]');
        if (!text || !text.value.trim()) {
          e.preventDefault();
          if (window.LMToast) window.LMToast('Please write your review first');
          return;
        }
        var productTitle = (document.querySelector('[data-product-section]') || {}).getAttribute
          ? document.querySelector('[data-product-section]').getAttribute('data-product-handle')
          : '';
        hiddenBody.value = 'Product review for: ' + (document.title || productTitle) +
          '\nRating: ' + rating + '/5\n\n' + text.value;
      });
    }
  })();

  (function initScratchPopup() {
    var backdrop = document.querySelector('[data-scratch-backdrop]');
    var modal = document.querySelector('[data-scratch-modal]');
    if (!backdrop || !modal) return;

    var STORAGE_KEY = 'lmScratchShown';
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    var stepScratch = modal.querySelector('[data-scratch-step-scratch]');
    var stepEmail = modal.querySelector('[data-scratch-step-email]');
    var stepDone = modal.querySelector('[data-scratch-step-done]');
    var canvas = modal.querySelector('[data-scratch-canvas]');

    function open() {
      backdrop.classList.add('is-visible');
      modal.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      sessionStorage.setItem(STORAGE_KEY, '1');
    }
    function close() {
      backdrop.classList.remove('is-visible');
      modal.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    backdrop.addEventListener('click', close);
    modal.querySelector('[data-scratch-close]').addEventListener('click', close);

    function showStep(step) {
      stepScratch.hidden = step !== 'scratch';
      stepEmail.hidden = step !== 'email';
      stepDone.hidden = step !== 'done';
    }

    if (canvas) {
      var ctx = canvas.getContext('2d');
      var w = canvas.width, h = canvas.height;
      var gradient = ctx.createLinearGradient(0, 0, w, h);
      gradient.addColorStop(0, '#E8C874');
      gradient.addColorStop(1, '#C9A24A');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, w, h);
      ctx.font = '700 15px sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.textAlign = 'center';
      ctx.fillText('SCRATCH HERE', w / 2, h / 2 + 5);

      var scratching = false;
      var revealed = false;

      function getPos(e) {
        var rect = canvas.getBoundingClientRect();
        var scaleX = w / rect.width, scaleY = h / rect.height;
        var point = e.touches ? e.touches[0] : e;
        return { x: (point.clientX - rect.left) * scaleX, y: (point.clientY - rect.top) * scaleY };
      }
      function scratchAt(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, 18, 0, Math.PI * 2);
        ctx.fill();
      }
      function checkRevealed() {
        if (revealed) return;
        var data = ctx.getImageData(0, 0, w, h).data;
        var cleared = 0;
        for (var i = 3; i < data.length; i += 4 * 20) { if (data[i] === 0) cleared++; }
        var pct = cleared / (data.length / (4 * 20));
        if (pct > 0.35) {
          revealed = true;
          ctx.clearRect(0, 0, w, h);
          setTimeout(function () { showStep('email'); }, 700);
        }
      }
      function start(e) { scratching = true; scratchAt(getPos(e).x, getPos(e).y); e.preventDefault(); }
      function move(e) { if (!scratching) return; var p = getPos(e); scratchAt(p.x, p.y); checkRevealed(); e.preventDefault(); }
      function end() { scratching = false; }

      canvas.addEventListener('mousedown', start);
      canvas.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      canvas.addEventListener('touchstart', start, { passive: false });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', end);
    }

    var emailForm = modal.querySelector('[data-scratch-step-email] form');
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fetch(emailForm.action, { method: 'POST', body: new FormData(emailForm) }).finally(function () {
          showStep('done');
        });
      });
    }

    var shopNowBtn = modal.querySelector('[data-scratch-shopnow]');
    if (shopNowBtn) shopNowBtn.addEventListener('click', close);

    setTimeout(open, 4000);
  })();

})();

/* Footer columns fold away on a phone. The panels are open markup; only the
   narrow screen closes them, so a visitor with JavaScript off, or on a wide
   screen, sees the footer exactly as it was. */
(function () {
  var MOBIEL = '(max-width: 859px)';

  function init() {
    var kolommen = document.querySelectorAll('[data-footer-col]');
    if (!kolommen.length) return;

    function zetOpen(kolom, open) {
      kolom.classList.toggle('is-open', open);
      var knop = kolom.querySelector('[data-footer-toggle]');
      if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Boven 859px staat alles open en doet de knop niets.
    function pasAan() {
      var smal = window.matchMedia(MOBIEL).matches;
      kolommen.forEach(function (kolom) {
        if (!smal) zetOpen(kolom, true);
        else if (!kolom.hasAttribute('data-footer-touched')) zetOpen(kolom, false);
      });
    }

    kolommen.forEach(function (kolom) {
      var knop = kolom.querySelector('[data-footer-toggle]');
      if (!knop) return;
      knop.addEventListener('click', function () {
        if (!window.matchMedia(MOBIEL).matches) return;
        kolom.setAttribute('data-footer-touched', '');
        zetOpen(kolom, !kolom.classList.contains('is-open'));
      });
    });

    pasAan();
    window.matchMedia(MOBIEL).addEventListener('change', function () {
      kolommen.forEach(function (k) { k.removeAttribute('data-footer-touched'); });
      pasAan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
